import copy from './serviceEditorial.json';
export function editorialPage(slug, language) {
  const item = copy[slug];
  return item ? { ...item, ...item[language === 'fa' ? 'fa' : 'en'] } : null;
}
